import { render, staticRenderFns } from "./message-abstract-text.vue?vue&type=template&id=4403514e&scoped=true"
import script from "./message-abstract-text.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-abstract-text.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-abstract-text.vue?vue&type=style&index=0&id=4403514e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4403514e",
  null
  
)

export default component.exports